import {
  fetchMissions,
  fetchVersions,
  fetchLatestVersion,
  createVersion,
  fetchMissionById,
} from "./missionsActions";
import {
  getMissionsState,
  getMastersById,
  getMasterIds,
  getVersionsByMasterId,
  getVersionsLoading,
  getSelectedMasterId,
  getSelectedVersionId,
  getMissionsLoading,
  getMissionsError,
  getAllMasters,
  getMasterById,
  getVersions,
  getLatestVersion,
  getSelectedMaster,
  getSelectedVersion,
  getMastersBySemanticMap,
  areVersionsLoaded,
  areVersionsLoading,
  getMastersCount,
  getVersionsCount,
  hasMasters,
  getMastersWithLatestVersions,
  getMastersGroupedBySemanticMap,
  getDefaultVersion,
  hasVersion,
  getVersionsSortedDesc,
  getVersionsSortedAsc,
} from "./missionsSelectors";
import MissionsSlice from "./missionsSlice";

// Sync actions (reducers)
export const {
  setMasters,
  addMaster,
  updateMaster,
  removeMaster,
  setVersions,
  addVersion,
  updateVersion,
  removeVersion,
  selectMaster,
  selectVersion,
  clearSelection,
  setVersionsLoading,
  resetMissions,
  setError,
  setLoading,
} = MissionsSlice.actions;

// Async actions
export {
  fetchMissions,
  fetchVersions,
  fetchLatestVersion,
  createVersion,
  fetchMissionById,
};

// Selectors
export {
  getMissionsState,
  getMastersById,
  getMasterIds,
  getVersionsByMasterId,
  getVersionsLoading,
  getSelectedMasterId,
  getSelectedVersionId,
  getMissionsLoading,
  getMissionsError,
  getAllMasters,
  getMasterById,
  getVersions,
  getLatestVersion,
  getSelectedMaster,
  getSelectedVersion,
  getMastersBySemanticMap,
  areVersionsLoaded,
  areVersionsLoading,
  getMastersCount,
  getVersionsCount,
  hasMasters,
  getMastersWithLatestVersions,
  getMastersGroupedBySemanticMap,
  getDefaultVersion,
  hasVersion,
  getVersionsSortedDesc,
  getVersionsSortedAsc,
};

// Reducer
export default MissionsSlice.reducer;
